module.exports = __webpack_public_path__ + "img/success_icon.2a1c3c1d.png";